const contacts = Object.freeze({
	phoneNumber: "+39.0957463250",
	phoneNumberURI: "tel:+390957463250",
	website: "https://uloi.cloud/",
	whatsappURL: "https://api.whatsapp.com/send/?phone=390957463250"
});

export default contacts;
